import { GetterTree } from 'vuex';
import { ListInfo, ListModel } from '@descomplica/dex-models';
import { ListState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ListState, RootState> = {
  allLists: (state, listsGetters) => {
    return Object.values(state.lists)
      .sort((a, b) => (a.metadata < b.metadata ? -1 : 1)) // To sort as it comes from Hygraph
      .map((list) => new ListModel(list, listsGetters));
  },

  listById: (state, listsGetters) => (listId: number) => {
    const list = state.lists[listId.toString()];
    return list ? new ListModel(list, listsGetters) : undefined;
  },

  listBySlug: (state, listsGetters) => (listSlug: string) => {
    const foundList = Object.values(state.lists).find((list: ListInfo) => list.slug === listSlug);
    return foundList && new ListModel(foundList, listsGetters);
  },

  listProgressById: (state) => (listId: number) => {
    return state.listsProgressMap[listId.toString()];
  },
};

export default getters;
